<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="table-wrap">
        <el-form label-width="80px" @submit.native.prevent>
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item :label="$t('text.sbsn')">
                <el-input
                  v-model="deviceForms.gatewaysn"
                  :placeholder="$t('placeholder.srxlh')"
                  clearable
                  @keyup.enter.native.prevent="handleQuery"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="mb10" :gutter="10">
          <el-button
            plain
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd"
          >{{ $t('button.bd') }}</el-button>
        </el-row>
        <el-table :data="tablist.queryResults" border>
          <el-table-column
            :label="$t('text.zdmc')"
            prop="orgname"
            align="center"
          />
          <el-table-column
            :label="$t('text.sbxlh')"
            prop="gatewaysn"
            align="center"
          />
          <el-table-column
            :label="$t('text.dblx')"
            prop="devicetype"
            align="center"
            :formatter="commonFormat"
          />
          <el-table-column
            :label="$t('text.yhmc')"
            prop="username"
            align="center"
          />
          <el-table-column
            :label="$t('text.sblx')"
            prop="gtype"
            align="center"
            :formatter="commonFormat"
          />
          <el-table-column
            :label="$t('text.cz')"
            align="center"
          >
            <template v-slot="scope">
              <el-button
                type="text"
                icon="el-icon-close"
                style="color:#F95868"
                @click="unBundling(scope.row.deviceid)"
              >{{ $t('button.jb') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          v-if="total>0"
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="getPageData"
        />
      </el-card>
      <el-dialog
        :title="$t(dialogAddTitle)"
        :visible.sync="showAddDialog"
        width="600px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="device"
          label-width="110px"
        >
          <el-form-item :label="$t('text.sblx')">
            <el-select v-model="devType">
              <el-option :label="$t('text.db')" value="0" />
              <el-option :label="$t('text.qx')" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.sbxlh')">
            <el-input v-model="device.sn" />
          </el-form-item>
          <el-form-item v-if="devType==='0'" :label="$t('text.sbyt')">
            <el-select v-model="device.devicetype">
              <el-option :label="$t('text.yddb')" value="0" />
              <el-option :label="$t('text.gfdb')" value="1" />
            </el-select>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click=" handleSubmit"
          >{{ $t('button.qd') }}</el-button>
          <el-button @click="showAddDialog = false">{{ $t('button.qx') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { QueryBindGateway, DeleteBind, BindWeatherDevice } from '@/api/TV'
import { DeviceBind } from '@/api/Stations'

export default {
  name: 'ListContent',
  components: {

  },
  data () {
    return {
      deviceForms: { orgid: this.$store.getters.station.id },
      tablist: [],
      pageNum: 1,
      pageSize: 15,
      total: 0,
      showAddDialog: false,
      dialogAddTitle: 'text.bdsb',
      devType: '0',
      device: {
        orgid: this.$store.getters.station.id
      }
    }
  },
  created () {
    this.getPageData()
  },
  methods: {
    getPageData () {
      QueryBindGateway({
        page: this.pageNum,
        perPage: this.pageSize,
        orderBy: 'gatewaysn',
        whereCondition: JSON.stringify(this.deviceForms)
      }).then(res => {
        this.tablist = res.data
        this.total = res.data.totalCount
      })
    },

    handleSubmit () {
      if (this.devType === '0') {
        DeviceBind(this.device)
          .then(res => {
            this.$msgSuccess(this.$t('notice.sbbdcg'))
            this.device.sn = ''
          })
      } else if (this.devType === '1') {
        BindWeatherDevice(this.device)
          .then(res => {
            this.$msgSuccess(this.$t('notice.sbbdcg'))
            this.device.sn = ''
          })
      }
    },

    unBundling (deviceid) {
      this.$confirm(this.$t('notice.sfjb'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      })
        .then(() => {
          return DeleteBind({ id: deviceid })
        })
        .then(() => {
          this.$msgSuccess(this.$t('notice.jbcg'))
          this.getPageData()
        })
        .catch(() => {
          this.$msgInfo(this.$t('notice.qxjb'))
        })
    },

    handleQuery () {
      this.pageNum = 1
      this.getPageData()
    },

    handleAdd () {
      this.showAddDialog = true
    },

    commonFormat (row, column, cellValue) {
      if (cellValue === '0' && column.property === 'devicetype') {
        return '用电电表'
      } else if (cellValue === '1' && column.property === 'devicetype') {
        return '光伏电表'
      } else if (cellValue === '0' && column.property === 'gtype') {
        return '组串'
      } else if (cellValue === '1' && column.property === 'gtype') {
        return '储能'
      } else if (cellValue === '2' && column.property === 'gtype') {
        return '气象'
      } else if (cellValue === '3' && column.property === 'gtype') {
        return '电表'
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.app-container{
  margin-right 5px
  padding 10px
  background-color: #F8F8F8
}
.el-table{
  margin-top: 10px
}
>>> .el-dialog__footer
  text-align: center

</style>

